import React, { useState, useEffect } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import MainLayout from "../../../../components/layout/MainLayout";
import Breadcrumbs from "../../../../components/common/Breadcrumbs";
import ComplaintForm from "./ComplaintForm";
import { useDispatch, useSelector } from "react-redux";
import {
    fetchComplaintForm,
    updateComplaintForm
} from "../../../../store/slices/complaintFormSlice";

const EditComplaint = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { id } = useParams();
    const { state } = useLocation();
    const { caseId, patientId } = state || {};

    const [formData, setFormData] = useState({});

    const { currentForm, isLoading } = useSelector(
        (state) => state.complaintForm
    );

    // FETCH FORM BY ID
    useEffect(() => {
        dispatch(fetchComplaintForm(id));
    }, [dispatch, id]);

    // console.log("complaintForm from Redux:", complaintForm);

    // MAP snake_case → camelCase when loaded
    useEffect(() => {
        if (currentForm) {
            setFormData({
                caseId: currentForm.case_id,
                patientId: currentForm.patient_id,

                dateOfComplaint: currentForm.date_of_complaint,
                department: currentForm.department,
                otherDepartment: currentForm.other_department,

                complaintDescription: currentForm.complaint_description,
                suggestedSolution: currentForm.suggested_solution,

                resolutionSummary: currentForm.resolution_summary,
                dateOfResolution: currentForm.date_of_resolution,

                resolvedBy: currentForm.resolved_by,
                staffDateOfResolution: currentForm.staff_date_of_resolution,

                adminRepresentative: currentForm.admin_representative,
                adminDate: currentForm.admin_date,
            });
        }
    }, [currentForm]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // camelCase → snake_case before update
        const payload = {
            case_id: formData.caseId,
            patient_id: formData.patientId,

            date_of_complaint: formData.dateOfComplaint,
            department: formData.department,
            other_department: formData.department === "Other" ? formData.otherDepartment : null,

            complaint_description: formData.complaintDescription,
            suggested_solution: formData.suggestedSolution,

            resolution_summary: formData.resolutionSummary,
            date_of_resolution: formData.dateOfResolution,

            resolved_by: formData.resolvedBy,
            staff_date_of_resolution: formData.staffDateOfResolution,

            admin_representative: formData.adminRepresentative,
            admin_date: formData.adminDate,
        };

        const result = await dispatch(
            updateComplaintForm({ case_id: caseId, data: payload })
        );

        if (result?.meta?.requestStatus === "fulfilled") {
            Swal.fire("Updated!", "Complaint form updated successfully.", "success");
            // Stay on edit page
        } else {
            Swal.fire("Error!", "Update failed.", "error");
        }
    };

    return (
        <MainLayout>
            <div className="container-xxl flex-grow-1 container-p-y">
                <Breadcrumbs />

                <div className="card">
                    <div className="card-body">

                        {isLoading || !currentForm ? <p>Loading...</p>
                            : (
                                <form onSubmit={handleSubmit}>
                                    <ComplaintForm
                                        formData={formData}
                                        handleChange={handleChange}
                                    />

                                    <div className="col-12 d-flex justify-content-end mt-3">
                                        <div className="col-md-2 d-flex justify-content-end">
                                            <button type="submit" className="btn btn-primary px-4">
                                                <i className="ri-edit-2-line me-1"></i>
                                                Update
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            )}
                    </div>
                </div>

            </div>
        </MainLayout>
    );
};

export default EditComplaint;
